"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Separator } from "@/components/ui/separator";
export default function ShopTitle() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.3
  });
  const {
    ref: paragraphRef,
    isVisible: paragraphVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: statRef,
    isVisible: statVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const storeLetters = ["M", "O", "B", "I", "L", "E", "."];
  return <section data-section-id="203" id="shop-title" className="relative bg-background text-foreground pt-28 md:pt-32 lg:pt-[120px] pb-16 md:pb-20 lg:pb-[80px] px-6 md:px-10 lg:px-16 overflow-hidden">
      {}
      <div className="pointer-events-none absolute inset-0 opacity-[0.03] mix-blend-overlay" style={{
      backgroundImage: "radial-gradient(var(--foreground) 1px, transparent 1px)",
      backgroundSize: "40px 40px"
    }} aria-hidden="true" />

      {}
      <div className="hidden lg:flex absolute right-4 top-1/2 -translate-y-1/2 origin-center rotate-90 items-center gap-2 font-mono text-[10px] tracking-[0.3em] text-muted-foreground/70 uppercase" aria-hidden="true">
        <span>TechWire &middot; Series 2025 &middot; Edition</span>
      </div>

      <div className="relative mx-auto max-w-7xl">
        {}
        <div className="flex justify-center">
          <p className="font-mono text-[10px] md:text-xs tracking-[0.2em] uppercase text-[var(--chart-1)] text-center">
            <span aria-hidden="true">&mdash;&mdash;&nbsp;</span>
            Flagship Devices &middot; Premium Accessories &middot; Expert Repair
          </p>
        </div>

        {}
        <div className="mt-12 md:mt-16 grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-start">
          {}
          <div className="lg:col-span-8">
            <h1 ref={headlineRef} className="font-default font-extrabold leading-[0.9] tracking-tighter text-foreground" style={{
            fontSize: "clamp(80px, 14vw, 160px)"
          }}>
              <span className="block">TECH&nbsp;/</span>
              <span className="block" aria-label="MOBILE.">
                {storeLetters.map((letter, i) => <span key={i} data-index={i} className="inline-block text-[var(--chart-1)] transition-all duration-700 ease-out" style={{
                opacity: headlineVisible ? 1 : 0,
                transform: headlineVisible ? "translateY(0)" : "translateY(0.4em)",
                transitionDelay: `${i * 90}ms`
              }} aria-hidden="true">
                    {letter}
                  </span>)}
              </span>
            </h1>

            {}
            <div className="mt-4 md:mt-6 flex items-center" aria-hidden="true">
              <svg width="180" height="20" viewBox="0 0 180 20" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-[var(--chart-1)]">
                <path d="M0 10 L 180 10" stroke="currentColor" strokeWidth="2" strokeLinecap="square" fill="none" />
              </svg>
            </div>
          </div>

          {}
          <div ref={paragraphRef} className="lg:col-span-4 lg:pt-32 xl:pt-40 max-w-[420px] transition-all duration-700 ease-out" style={{
          opacity: paragraphVisible ? 1 : 0,
          transform: paragraphVisible ? "translateY(0)" : "translateY(1rem)",
          transitionDelay: "400ms"
        }}>
            <p className="font-default text-base md:text-lg leading-relaxed text-foreground/85">
              Precision-engineered smartphones and professional-grade accessories. Experience the next generation of mobile technology with TechWire.
            </p>
          </div>
        </div>

        {}
        <div className="mt-16 md:mt-20 flex items-center gap-6">
          <Separator className="flex-1 bg-border" />
          <div className="text-[var(--chart-1)] shrink-0" aria-hidden="true" title="Circuit icon">
            <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="4" y="4" width="28" height="28" stroke="currentColor" strokeWidth="2" />
              <rect x="12" y="12" width="12" height="12" stroke="currentColor" strokeWidth="2" />
              <path d="M10 10 L 12 12 M26 10 L 24 12 M10 26 L 12 24 M26 26 L 24 24" stroke="currentColor" strokeWidth="2" />
            </svg>
          </div>
          <Separator className="flex-1 bg-border" />
        </div>

        {}
        <div ref={statRef} className="mt-8 flex justify-center transition-all duration-700 ease-out" style={{
        opacity: statVisible ? 1 : 0,
        transform: statVisible ? "translateY(0)" : "translateY(0.5rem)",
        transitionDelay: "200ms"
      }}>
          <p className="font-mono text-[10px] md:text-xs tracking-[0.2em] uppercase text-muted-foreground text-center">
            <span aria-hidden="true">&mdash;&nbsp;</span>
            120+ Models &middot; Certified Quality &middot; Fast Secure Shipping
          </p>
        </div>
      </div>
    </section>;
}